import cache from "./cache";
import { authApi } from "../api/authApi";
import { productApi } from "../api/productApi";
import { pricingApi } from "../api/pricingApi";
import { orderApi } from "../api/orderApi";
import { supplierApi } from "../api/supplierApi";
import { shopifyApi } from "../api/shopifyApi";
import { ebayApi } from "../api/ebayApi";
import { dashboardApi } from "../api/dashboardApi";

const apiSlices = [
  authApi,
  productApi,
  pricingApi,
  orderApi,
  supplierApi,
  shopifyApi,
  ebayApi,
  dashboardApi,
];

export async function performLogout({ dispatch, navigate, logoutMutation }) {
  try {
    await logoutMutation().unwrap();
  } catch {
    // fail-open: always clear client state (D-14)
  }
  apiSlices.forEach((api) => {
    dispatch(api.util.resetApiState());
  });
  cache.removeItem("user");
  navigate("/");
}
